module.exports = __webpack_public_path__ + "img/UTGOBL-10.3379f2d5.jpg";